import { render, staticRenderFns } from "./appealFeedbackDialog.vue?vue&type=template&id=064775fd&scoped=true"
import script from "./appealFeedbackDialog.vue?vue&type=script&lang=js"
export * from "./appealFeedbackDialog.vue?vue&type=script&lang=js"
import style0 from "./appealFeedbackDialog.vue?vue&type=style&index=0&id=064775fd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064775fd",
  null
  
)

export default component.exports